import React, { useEffect, useState } from "react";
import Sidebar from "../../sidebar";
import Topnav from "../../TopNav";
import { useNavigate } from 'react-router-dom';
import { API_URL, token } from "../../config";
import { ClipLoader, BarLoader } from "react-spinners";
import Swal from "sweetalert2";
import '../../Courses/Courses.css';
import { getCurrentDate } from "../../Components/DateFunction";

const AdminPanel = () => {
    // State declarations
    const [dataSource, setDataSource] = useState([]);
    const [filteredDataSource, setFilteredDataSource] = useState([]);
    const [dataSource2, setDataSource2] = useState([]);
    const [accBal, setAccBal] = useState(0);
    const [subscriptionsCount, setSubscriptionsCount] = useState(0);
    const [subscribed, setSubscribed] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [textHeader, setTextHeader] = useState('');
    const [text, setText] = useState('');
    const [showAddModal, setShowAddModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [teacher, setTeacher] = useState('');
    const [price, setPrice] = useState('');
    const [file, setFile] = useState(null);
    const [hide, setHide] = useState(false);
    const [currentView, setCurrentView] = useState('levels');
    const [selectedLevel, setSelectedLevel] = useState('');
    const [selectedSubject, setSelectedSubject] = useState('');
    const [availableLevels, setAvailableLevels] = useState([]);
    const [availableSubjects, setAvailableSubjects] = useState([]);
    const [isLoadingTopics, setIsLoadingTopics] = useState(false);

    // Navigation and IDs
    const navigate = useNavigate();
    const storedUser = localStorage.getItem('user');
    const user = storedUser ? JSON.parse(storedUser) : null;
    const userId = user ? user.user_id : null;
    const channelName = localStorage.getItem('myChannel') || localStorage.getItem('collegeName');
    const channelId = localStorage.getItem('myChannelId') || localStorage.getItem('collegeId');
    const courseId = localStorage.getItem('courseId') || '';
    const courseName = localStorage.getItem('courseName') || '';
    const moduleId = localStorage.getItem('moduleId') || '';

    // Toggle sidebar
    const toggleSidebar = () => {
        setHide(prevHide => !prevHide);
    };

    // Responsive handling
    useEffect(() => {
        const handleResize = () => {
            const screenWidth = window.innerWidth;
            if (screenWidth < 768) {
                setHide(true);
            }
        };

        window.addEventListener('resize', handleResize);
        handleResize();

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    // Filter data based on search term
    useEffect(() => {
        if (searchTerm === '') {
            setFilteredDataSource(dataSource);
        } else {
            const filtered = dataSource.filter(item =>
                item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                (item.description && item.description.toLowerCase().includes(searchTerm.toLowerCase()))
            );
            setFilteredDataSource(filtered);
        }
    }, [searchTerm, dataSource]);

    // Main data fetching effect
    useEffect(() => {
        if (localStorage.getItem('userRole') !== "Admin") {
            navigate('/courses');
            return;
        }

        fetchAccountBalance();
        fetchSubscriptions();
        fetchSubscriptionCount();

        switch (currentView) {
            case 'levels':
                fetchLevels();
                break;
            case 'subjects':
                fetchSubjects();
                fetchLevelsForDropdown();
                break;
            case 'topics':
                fetchTopics();
                fetchSubjectsForDropdown();
                break;
            default:
                break;
        }
    }, [currentView, channelId, selectedLevel, selectedSubject]);

    // Data fetching functions
    const fetchAccountBalance = async () => {
        try {
            const response = await fetch(`${API_URL}/account/bal/${channelId}`, {
                headers: { 'Authorization': `Bearer ${token()}` }
            });
            if (!response.ok) throw new Error('Network response was not ok');
            const data = await response.json();
            setAccBal(data.bal);
        } catch (error) {
            console.error("Error fetching account balance:", error);
        }
    };

    const fetchSubscriptions = async () => {
        try {
            const endpoint = currentView === 'levels'
                ? `${API_URL}/subscriptions/college/mod/${channelId}/${getCurrentDate()}`
                : currentView === 'subjects'
                    ? `${API_URL}/subscriptions/course/mod/${courseId}/${getCurrentDate()}`
                    : `${API_URL}/subscriptions/module/lessons/${moduleId}/${getCurrentDate()}`;

            const response = await fetch(endpoint, {
                headers: { 'Authorization': `Bearer ${token()}` }
            });
            if (!response.ok) throw new Error('Network response was not ok');
            const data = await response.json();
            setDataSource2(data);
        } catch (error) {
            console.error("Error fetching subscriptions:", error);
        }
    };

    const fetchSubscriptionCount = async () => {
        try {
            const response = await fetch(`${API_URL}/subscriptions`, {
                headers: { 'Authorization': `Bearer ${token()}` }
            });
            if (!response.ok) throw new Error('Network response was not ok');
            const data = await response.json();
            setSubscriptionsCount(data.length);
        } catch (error) {
            console.error("Error fetching subscription count:", error);
        }
    };

    const fetchLevels = async () => {
        try {
            const response = await fetch(`${API_URL}/colleges`, {
                headers: { 'Authorization': `Bearer ${token()}` }
            });
            if (!response.ok) throw new Error('Network response was not ok');
            const data = await response.json();
            setDataSource(data);
            setFilteredDataSource(data);
            setSubscribed(data.length > 0);
            if (data.length < 1) {
                setTextHeader(`Welcome to TANTAK e-learning portal.`);
                setText(`To get started click "Add Level" button and enter level details.`);
            }
        } catch (error) {
            console.error("Error fetching levels:", error);
        }
    };

    const fetchSubjects = async () => {
        try {
            const effectiveLevelId = selectedLevel || channelId;
            console.log("Fetching subjects for level:", effectiveLevelId);

            const response = await fetch(`${API_URL}/courses/college/${effectiveLevelId}`, {
                headers: { 'Authorization': `Bearer ${token()}` }
            });

            if (!response.ok) throw new Error('Network response was not ok');
            const data = await response.json();
            setDataSource(data);
            setFilteredDataSource(data);
            setSubscribed(data.length > 0);

            if (data.length < 1) {
                setTextHeader(`Welcome to TANTAK e-learning portal.`);
                setText(`To get started click "Add Subject" button and enter subject details.`);
            }
        } catch (error) {
            console.error("Error fetching subjects:", error);
        }
    };

    const fetchTopics = async () => {
        setIsLoadingTopics(true);
        try {
            const effectiveCourseId = selectedSubject || courseId;
            console.log("Fetching topics for course:", effectiveCourseId);

            const response = await fetch(`${API_URL}/modules/course/${effectiveCourseId}`, {
                headers: { 'Authorization': `Bearer ${token()}` }
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Failed to fetch topics');
            }

            const data = await response.json();
            console.log("Topics data:", data);
            setDataSource(data);
            setFilteredDataSource(data);
            setSubscribed(data.length > 0);

            if (data.length < 1) {
                setTextHeader(`No topics available in this subject!`);
                setText(`To get started click "Add Topic" button and enter topic details.`);
            }
        } catch (error) {
            console.error("Error fetching topics:", error);
            Swal.fire({
                text: error.message || "Failed to load topics",
                icon: "error"
            });
        } finally {
            setIsLoadingTopics(false);
        }
    };

    const fetchLevelsForDropdown = async () => {
        try {
            const response = await fetch(`${API_URL}/colleges`, {
                headers: { 'Authorization': `Bearer ${token()}` }
            });
            if (!response.ok) throw new Error('Network response was not ok');
            const data = await response.json();
            setAvailableLevels(data);
        } catch (error) {
            console.error("Error fetching levels for dropdown:", error);
        }
    };

    const fetchSubjectsForDropdown = async () => {
        try {
            const response = await fetch(`${API_URL}/courses/college/${channelId}`, {
                headers: { 'Authorization': `Bearer ${token()}` }
            });
            if (!response.ok) throw new Error('Network response was not ok');
            const data = await response.json();
            setAvailableSubjects(data);
        } catch (error) {
            console.error("Error fetching subjects for dropdown:", error);
        }
    };

    // Navigation handlers
    const handleView = (id, name = '') => {
        setDataSource([]);
        setFilteredDataSource([]);

        switch (currentView) {
            case 'levels':
                localStorage.setItem('collegeId', id);
                localStorage.setItem('collegeName', name);
                setSelectedLevel(id);
                setCurrentView('subjects');
                break;
            case 'subjects':
                localStorage.setItem('courseId', id);
                localStorage.setItem('courseName', name);
                setSelectedSubject(id);
                setCurrentView('topics');
                break;
            case 'topics':
                localStorage.setItem('moduleId', id);
                localStorage.setItem('Admin', userId);
                navigate('/dashboard');
                break;
            default:
                break;
        }
    };

    const handleBack = () => {

        setDataSource([]);
        setFilteredDataSource([]);

        switch (currentView) {
            case 'subjects':
                localStorage.removeItem('collegeId');
                localStorage.removeItem('collegeName');
                setSelectedLevel('');
                setCurrentView('levels');
                break;
            case 'topics':
                localStorage.removeItem('courseId');
                localStorage.removeItem('courseName');
                setSelectedSubject('');
                setCurrentView('subjects');
                break;
            default:
                break;
        }
    };

    // Form handlers
    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            let endpoint, method, payload;

            switch (currentView) {
                case 'levels':
                    endpoint = `${API_URL}/colleges`;
                    method = 'POST';
                    payload = {
                        adminId: userId,
                        name: name,
                        description: description,
                        profile_pic: null
                    };
                    break;
                case 'subjects':
                    endpoint = `${API_URL}/courses/course`;
                    method = 'POST';
                    const subjectFormData = new FormData();
                    subjectFormData.append('college_id', selectedLevel || channelId);
                    subjectFormData.append('name', name);
                    subjectFormData.append('description', description);
                    subjectFormData.append('instructor', null);
                    subjectFormData.append('price', price);
                    if (file) subjectFormData.append('file', file);
                    payload = subjectFormData;
                    break;
                case 'topics':
                    endpoint = `${API_URL}/modules/module`;
                    method = 'POST';
                    const topicFormData = new FormData();
                    topicFormData.append('course_id', selectedSubject || courseId);
                    topicFormData.append('name', name);
                    topicFormData.append('description', description);
                    topicFormData.append('instructor', teacher);
                    topicFormData.append('price', '0');
                    if (file) topicFormData.append('file', file);
                    payload = topicFormData;
                    break;
                default:
                    break;
            }

            const headers = {
                'Authorization': `Bearer ${token()}`,
                ...(typeof payload === 'object' && !(payload instanceof FormData) && { 'Content-Type': 'application/json' })
            };

            const body = payload instanceof FormData ? payload : JSON.stringify(payload);

            const response = await fetch(endpoint, { method, headers, body });
            if (!response.ok) throw new Error(currentView === 'levels' ? 'Addition failed' : 'Failed to upload');

            const data = await response.json();

            if (data.status && data.status !== '200') {
                throw new Error(data.message || "Teacher email not found in the system.");
            }

            setShowAddModal(false);
            Swal.fire({
                text: `${currentView.slice(0, -1).charAt(0).toUpperCase() + currentView.slice(0, -1).slice(1)} added successfully!`,
                icon: "success"
            });

            // Refresh data
            switch (currentView) {
                case 'levels':
                    fetchLevels();
                    break;
                case 'subjects':
                    fetchSubjects();
                    break;
                case 'topics':
                    fetchTopics();
                    break;
                default:
                    break;
            }
        } catch (error) {
            Swal.fire({
                text: error.message || "An error occurred!",
                icon: "error"
            });
        } finally {
            setIsLoading(false);
        }
    };

    // const handleSubmitEdit = async (e) => {
    //     e.preventDefault();
    //     setIsLoading(true);

    //     try {
    //         let endpoint, method, payload;
    //         let idToUse = '';

    //         switch (currentView) {
    //             case 'levels':
    //                 endpoint = `${API_URL}/colleges/${channelId}`;
    //                 method = 'PUT';
    //                 payload = {
    //                     name: name,
    //                     description: description
    //                 };
    //                 idToUse = channelId;
    //                 break;
    //             case 'subjects':
    //                 endpoint = `${API_URL}/courses/update/${courseId}`;
    //                 method = 'PUT';
    //                 const subjectFormData = new FormData();
    //                 subjectFormData.append('name', name);
    //                 subjectFormData.append('description', description);
    //                 subjectFormData.append('price', price);
    //                 payload = subjectFormData;
    //                 idToUse = courseId;
    //                 break;
    //             case 'topics':
    //                 endpoint = `${API_URL}/modules/${moduleId}`;
    //                 method = 'PUT';
    //                 const topicFormData = new FormData();
    //                 topicFormData.append('name', name);
    //                 topicFormData.append('description', description);
    //                 topicFormData.append('instructor', teacher);
    //                 topicFormData.append('price', '0');
    //                 payload = topicFormData;
    //                 idToUse = moduleId;
    //                 break;
    //             default:
    //                 break;
    //         }

    //         const headers = {
    //             'Authorization': `Bearer ${token()}`,
    //             ...(typeof payload === 'object' && !(payload instanceof FormData) && { 'Content-Type': 'application/json' })
    //         };

    //         const body = payload instanceof FormData ? payload : JSON.stringify(payload);

    //         const response = await fetch(endpoint, { method, headers, body });
    //         if (!response.ok) throw new Error('Update failed');

    //         const data = await response.json();

    //         if (data.status && data.status !== '200') {
    //             throw new Error(data.message || "Teacher email not found in the system.");
    //         }

    //         setShowEditModal(false);
    //         Swal.fire({
    //             text: "Updated successfully!",
    //             icon: "success"
    //         });

    //         // Refresh data
    //         switch (currentView) {
    //             case 'levels':
    //                 fetchLevels();
    //                 break;
    //             case 'subjects':
    //                 fetchSubjects();
    //                 break;
    //             case 'topics':
    //                 fetchTopics();
    //                 break;
    //             default:
    //                 break;
    //         }
    //     } catch (error) {
    //         Swal.fire({
    //             text: error.message || "An error occurred while updating!",
    //             icon: "error"
    //         });
    //     } finally {
    //         setIsLoading(false);
    //     }
    // };

    const handleSubmitEdit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            let endpoint, method, payload;
            let idToUse = '';

            switch (currentView) {
                case 'levels':
                    endpoint = `${API_URL}/colleges/${selectedLevel || channelId}`;
                    method = 'PUT';
                    payload = {
                        name: name,
                        description: description
                    };
                    idToUse = selectedLevel || channelId;
                    break;
                case 'subjects':
                    endpoint = `${API_URL}/courses/update/${selectedSubject || courseId}`;
                    method = 'PUT';
                    const subjectFormData = new FormData();
                    subjectFormData.append('college_id', selectedLevel || channelId); // Add college_id
                    subjectFormData.append('name', name);
                    subjectFormData.append('description', description);
                    subjectFormData.append('price', price);
                    if (file) subjectFormData.append('file', file);
                    payload = subjectFormData;
                    idToUse = selectedSubject || courseId;
                    break;
                case 'topics':
                    endpoint = `${API_URL}/modules/${selectedSubject || moduleId}`;
                    method = 'PUT';
                    const topicFormData = new FormData();
                    topicFormData.append('course_id', selectedLevel || courseId); // Add course_id
                    topicFormData.append('name', name);
                    topicFormData.append('description', description);
                    topicFormData.append('instructor', teacher);
                    topicFormData.append('price', '0');
                    if (file) topicFormData.append('file', file);
                    payload = topicFormData;
                    idToUse = selectedSubject || moduleId;
                    break;
                default:
                    break;
            }

            const headers = {
                'Authorization': `Bearer ${token()}`,
                ...(typeof payload === 'object' && !(payload instanceof FormData) && { 'Content-Type': 'application/json' })
            };

            const body = payload instanceof FormData ? payload : JSON.stringify(payload);

            const response = await fetch(endpoint, { method, headers, body });
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Update failed');
            }

            const data = await response.json();

            if (data.status && data.status !== '200') {
                throw new Error(data.message || "Teacher email not found in the system.");
            }

            setShowEditModal(false);
            Swal.fire({
                text: "Updated successfully!",
                icon: "success"
            });

            // Refresh data
            switch (currentView) {
                case 'levels':
                    fetchLevels();
                    break;
                case 'subjects':
                    fetchSubjects();
                    break;
                case 'topics':
                    fetchTopics();
                    break;
                default:
                    break;
            }
        } catch (error) {
            Swal.fire({
                text: error.message || "An error occurred while updating!",
                icon: "error"
            });
        } finally {
            setIsLoading(false);
        }
    };

    // Delete handler
    const handleDelete = async (id) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
        });

        if (!result.isConfirmed) return;

        try {
            let endpoint;
            switch (currentView) {
                case 'levels':
                    endpoint = `${API_URL}/colleges/${id}`;
                    break;
                case 'subjects':
                    endpoint = `${API_URL}/courses/${id}`;
                    break;
                case 'topics':
                    endpoint = `${API_URL}/modules/${id}`;
                    break;
                default:
                    break;
            }

            await fetch(endpoint, {
                method: 'DELETE',
                headers: {
                    'Authorization': `Bearer ${token()}`,
                }
            });

            Swal.fire({
                text: "Deleted Successfully!",
                icon: "success"
            });

            // Refresh data
            switch (currentView) {
                case 'levels':
                    fetchLevels();
                    break;
                case 'subjects':
                    fetchSubjects();
                    break;
                case 'topics':
                    fetchTopics();
                    break;
                default:
                    break;
            }
        } catch (error) {
            Swal.fire({
                text: "An error occurred while deleting!",
                icon: "error"
            });
        }
    };

    // Modal handlers
    const openModal = () => {
        setName('');
        setDescription('');
        setTeacher('');
        setPrice(currentView === 'topics' ? '0' : '');
        setFile(null);
        setShowAddModal(true);
    };


    const openEditModal = (element) => {
        setName(element.name);
        setDescription(element.description);
        setTeacher(element.email || element.instructor || '');
        setPrice(currentView === 'topics' ? '0' : element.price);
        setShowEditModal(true);

        // Set the appropriate IDs based on current view
        switch (currentView) {
            case 'levels':
                setSelectedLevel(element.college_id);
                break;
            case 'subjects':
                setSelectedLevel(element.college_id); // Set the college_id for subjects
                setSelectedSubject(element.course_id);
                break;
            case 'topics':
                setSelectedLevel(element.course_id); // Set the course_id for topics
                setSelectedSubject(element.module_id);
                break;
            default:
                break;
        }
    };

    const handleFileUpload = (event) => {
        setFile(event.target.files[0]);
    };

    // Handle search input change
    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };

    // Render functions
    const renderTable = () => {
        if (isLoadingTopics) {
            return <div className="text-center"><ClipLoader size={50} color={"#123abc"} /></div>;
        }

        if (!subscribed) {
            return (
                <div>
                    <p style={{ fontSize: '18px', textAlign: 'center' }}><b>{textHeader}</b></p>
                    <p style={{ fontSize: '16px', textAlign: 'center' }}>{text}</p>
                </div>
            );
        }

        const headers = {
            levels: ['Name', 'Description', 'Action'],
            subjects: ['Name', 'Description', 'Price', 'Action'],
            topics: ['Name', 'Description', 'Teacher', 'Action']
        };

        return (
            <div>
                <div className="mb-3">
                    <input
                        type="text"
                        className="form-control"
                        placeholder={`Search by name or description...`}
                        value={searchTerm}
                        onChange={handleSearchChange}
                    />
                </div>
                <table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                    <thead>
                        <tr>
                            {headers[currentView].map(header => (
                                <th key={header}>{header}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {filteredDataSource.map((element) => (
                            <tr key={element.college_id || element.course_id || element.module_id}>
                                <td>{element.name}</td>
                                <td>{element.description}</td>
                                {currentView === 'subjects' && <td>{element.price}</td>}
                                {currentView === 'topics' && (
                                    <td>{element.teacherName} {element.surname}</td>
                                )}
                                <td>
                                    <div className="d-flex align-items-center">
                                        <button type="button" className="btn btn-link" onClick={() => openEditModal(element)}>
                                            <p>Edit</p>
                                        </button>
                                        <button type="button" className="btn btn-link" onClick={() => handleView(
                                            currentView === 'levels' ? element.college_id :
                                                currentView === 'subjects' ? element.course_id :
                                                    element.module_id,
                                            element.name
                                        )}>
                                            <p>View</p>
                                        </button>
                                        <button type="button" className="btn btn-link" onClick={() => handleDelete(
                                            currentView === 'levels' ? element.college_id :
                                                currentView === 'subjects' ? element.course_id :
                                                    element.module_id
                                        )}>
                                            <p>Delete</p>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    };

    const renderModal = () => {
        const titles = {
            levels: { add: 'Add Level', edit: 'Edit Level' },
            subjects: { add: 'Add Subject', edit: 'Edit Subject' },
            topics: { add: 'Add Topic', edit: 'Edit Topic' }
        };

        return (
            <div className="modal fade show" style={{ display: 'block' }} onClick={() => showEditModal ? setShowEditModal(false) : setShowAddModal(false)}>
                <div className="modal-dialog" onClick={(e) => e.stopPropagation()}>
                    <div className="modal-content" style={{ boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)', borderRadius: '8px' }}>
                        <div className="modal-header">
                            <h5 className="modal-title">{showEditModal ? titles[currentView].edit : titles[currentView].add}</h5>
                            <button type="button" className="close" onClick={() => showEditModal ? setShowEditModal(false) : setShowAddModal(false)}>&times;</button>
                        </div>
                        <form onSubmit={showEditModal ? handleSubmitEdit : handleSubmit}>
                            <div className="modal-body">
                                {currentView === 'subjects' && availableLevels.length > 0 && (
                                    <div className="form-group">
                                        <label className="modal-label">Level</label>
                                        <select
                                            className="form-control"
                                            value={selectedLevel || channelId}
                                            onChange={(e) => setSelectedLevel(e.target.value)}
                                            required
                                        >
                                            {availableLevels.map(level => (
                                                <option key={level.college_id} value={level.college_id}>
                                                    {level.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                )}
                                {currentView === 'topics' && availableSubjects.length > 0 && (
                                    <div className="form-group">
                                        <label className="modal-label">Subject</label>
                                        <select
                                            className="form-control"
                                            value={selectedSubject || courseId}
                                            onChange={(e) => setSelectedSubject(e.target.value)}
                                            required
                                        >
                                            {availableSubjects.map(subject => (
                                                <option key={subject.course_id} value={subject.course_id}>
                                                    {subject.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                )}
                                <div className="form-group">
                                    <label className="modal-label">Name</label>
                                    <input type="text" className="form-control" value={name} onChange={(e) => setName(e.target.value)} required />
                                </div>
                                <div className="form-group">
                                    <label className="modal-label">Description</label>
                                    {currentView === 'levels' ? (
                                        <textarea className="form-control" value={description} onChange={(e) => setDescription(e.target.value)} required />
                                    ) : (
                                        <input type="text" className="form-control" value={description} onChange={(e) => setDescription(e.target.value)} required />
                                    )}
                                </div>
                                {currentView === 'subjects' && (
                                    <div className="form-group">
                                        <label className="modal-label">Price</label>
                                        <input type="number" className="form-control" value={price} onChange={(e) => setPrice(e.target.value)} required />
                                    </div>
                                )}
                                {currentView === 'topics' && (
                                    <div className="form-group">
                                        <label className="modal-label">Teacher's email</label>
                                        <input type="text" className="form-control" value={teacher} onChange={(e) => setTeacher(e.target.value)} required />
                                    </div>
                                )}
                                {/* {currentView !== 'levels' && (
                                    <div className="form-group">
                                        <label className="modal-label">Thumbnail Image</label>
                                        <input type="file" className="form-control" onChange={handleFileUpload} />
                                    </div>
                                )} */}
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => showEditModal ? setShowEditModal(false) : setShowAddModal(false)}>
                                    Close
                                </button>
                                {isLoading ? (
                                    <div style={{ marginTop: '8px', textAlign: 'center' }}>
                                        <div className="btn btn-primary" style={{ width: '5rem' }}>
                                            <ClipLoader loading={isLoading} size={27} color="white" />
                                        </div>
                                    </div>
                                ) : (
                                    <button type="submit" className="btn btn-primary">
                                        Submit
                                    </button>
                                )}
                            </div>
                            {isLoading && (
                                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '5px' }}>
                                    <BarLoader size={40} width={'100%'} color="blue" loading />
                                </div>
                            )}
                        </form>
                    </div>
                </div>
            </div>
        );
    };

    // const getViewTitle = () => {
    //     switch (currentView) {
    //         case 'levels':
    //             return `Admin Panel - Manage Subject Levels`;
    //         case 'subjects':
    //             // Use the selected level name if available, otherwise fall back to channelName from localStorage
    //             const levelName = availableLevels.find(level => level.college_id === (selectedLevel || channelId))?.name;
    //             return `Manage Subjects - ${levelName || channelName}`;
    //         case 'topics':
    //             // Use the selected subject name if available, otherwise fall back to courseName from localStorage
    //             const subjectName = availableSubjects.find(subject => subject.course_id === (selectedSubject || courseId))?.name;
    //             return `Manage Topics - ${channelName}${subjectName ? ` (${subjectName})` : courseName ? ` (${courseName})` : ''}`;
    //         default:
    //             return 'Admin Panel';
    //     }
    // };

    const getViewTitle = () => {
        switch (currentView) {
            case 'levels':
                return `Admin Panel - Manage Subject Levels`;
            case 'subjects':
                // For subjects view, show the current level name
                const levelName = availableLevels.find(level =>
                    level.college_id === (selectedLevel || channelId)
                )?.name;
                return `Manage Classes - ${levelName || channelName}`;
            case 'topics':
                // For topics view, we need to:
                // 1. Find the current subject to get its college_id
                // 2. Then find the level name using that college_id
                const currentSubject = availableSubjects.find(subject =>
                    subject.course_id === (selectedSubject || courseId)
                );

                // Get the level ID from the subject, fallback to selectedLevel or channelId
                const levelIdForTopic = currentSubject?.college_id || selectedLevel || channelId;

                // Find the level name
                const levelForTopic = availableLevels.find(level =>
                    level.college_id === levelIdForTopic
                );

                const subjectName = currentSubject?.name || courseName;
                const levelNameForTopic = levelForTopic?.name || channelName;

                return `Manage Topics - ${levelNameForTopic}${subjectName ? ` (${subjectName})` : ''}`;
            default:
                return 'Admin Panel';
        }
    };

    const getAddButtonText = () => {
        switch (currentView) {
            case 'levels':
                return 'Add Level';
            case 'subjects':
                return 'Add Subject';
            case 'topics':
                return 'Add Topic';
            default:
                return 'Add';
        }
    };

    const getTableTitle = () => {
        switch (currentView) {
            case 'levels':
                return 'Available Levels';
            case 'subjects':
                return 'Available Class';
            case 'topics':
                return 'Available Modules';
            default:
                return 'Data';
        }
    };

    return (
        <html lang="en">
            <body id="page-top">
                <div id="wrapper">
                    <Sidebar hide={hide}></Sidebar>
                    <div id="content-wrapper" className="d-flex flex-column">
                        <div id="content">
                            <Topnav toggleSidebar={toggleSidebar}></Topnav>
                            <div className="container-fluid" style={{ overflow: 'auto', maxHeight: '85vh', scrollbarWidth: 'none' }}>
                                <h1 className="h3 mb-4 text-gray-800">{getViewTitle()}</h1>

                                <div className="row mb-4">
                                    <div className="col-xl-4 col-md-6 mb-4">
                                        <div className="card border-left-primary shadow h-100 py-2">
                                            <div className="card-body">
                                                <div className="row no-gutters align-items-center">
                                                    <div className="col mr-2">
                                                        <div className="text-xs font-weight-bold text-primary text-uppercase mb-1">
                                                            {currentView === 'levels' ? 'Total Levels' :
                                                                currentView === 'subjects' ? 'Total Subjects' : 'Total Topics'}
                                                        </div>
                                                        <div className="h5 mb-0 font-weight-bold text-gray-800">{dataSource.length}</div>
                                                    </div>
                                                    <div className="col-auto">
                                                        <i className="las la-money-bill-wave fa-2x text-gray-300"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-xl-4 col-md-6 mb-4">
                                        <div className="card border-left-danger shadow h-100 py-2">
                                            <div className="card-body">
                                                <div className="row no-gutters align-items-center">
                                                    <div className="col mr-2">
                                                        <div className="text-xs font-weight-bold text-danger text-uppercase mb-1">Total Subscribers</div>
                                                        <div className="h5 mb-0 font-weight-bold text-gray-800">{subscriptionsCount}</div>
                                                    </div>
                                                    <div className="col-auto">
                                                        <i className="las la-exclamation-triangle fa-2x text-gray-300"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="d-sm-flex align-items-center justify-content-between mb-4">
                                    <h1 className="h3 mb-0 text-gray-800">{getTableTitle()}</h1>
                                    <div>
                                        {(currentView === 'subjects' || currentView === 'topics') && (
                                            <button onClick={handleBack} className="d-sm-inline-block btn btn-sm btn-secondary shadow-sm mr-2">
                                                <i className="fas fa-arrow-left fa-sm text-white-50"></i> Back
                                            </button>
                                        )}
                                        <button onClick={openModal} className="d-sm-inline-block btn btn-sm btn-primary shadow-sm">
                                            <i className="fas fa-plus fa-sm text-white-50"></i> {getAddButtonText()}
                                        </button>
                                    </div>
                                </div>
                                <div style={{ height: '35rem', overflowY: 'auto' }}>
                                    {renderTable()}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Modals */}
                {showAddModal && renderModal()}
                {showEditModal && renderModal()}
            </body>
        </html>
    );
};

export default AdminPanel;
